import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=104c8862&"
import script from "./TabsView.vue?vue&type=script&lang=ts&"
export * from "./TabsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports